import React,{useEffect} from "react";
import {Link } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';
import check from "../images/check.png";
const Social_Media_Marketing = () =>
{

return(
<>
<div className="web-page">
  <section className="">
    <div className="container px-0">
      <div className="row  xs-column-reverse  align-items-stretch">
        <div className="col-md-6 align-self-center">
          <div className="techUse-title ">
            <h1> <span className="sub-color">Social Media </span> Marketing </h1>
          </div>
         <p className="text-justify">Our digital marketing team specialises in creating and executing social media strategies that help businesses find online success. From social media account management and content creation to social media advertising, and analytics tracking, we offer a range of services, ensuring that our clients get the most out of their social media campaigns.</p>
          <Link to="/contact" className="btn btn-s">
          Let's Talk
          </Link>
        </div>
        <div className="col-md-6">
          <img src="../assets/img/solutions/smm.jpg" alt="" srcset="" className="img-fluid" />
        </div>
      </div>
    </div>
  </section>
  <section className="work-process py-5">
    <div className="container px-0">
      <div className="row">
        <div className="col-md-12">
          <div className="techUse-title text-center">
            <h1>Our <span className="sub-color"> Social Media </span> Marketing Process </h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
          <img src="../assets/img/solutions/SocialProcess.png" className="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section className="py-lg-5">
    <div className="container px-0">
      <div className="row justify-content-center pt-4">
        <div className="col-md-12 text-center">
          <div className="techUse-title text-center">
            <h1>Why Hire <span className="sub-color"> Social BFC Softtech's Media Marketing </span> Services?  </h1>
          </div>
          <p className="short-desc">BFC Softtech provides comprehensive social media marketing services, helping businesses establish a strong online presence, engage with their audience, and in-turn, increase conversions. Our experts help you develop and implement a social media plan that compliments your business objectives, helping you stand out in a crowded marketplace.
Our Social Media Marketing Services </p>
        </div>
      </div>
       <div className="row why-go pb-4">
        <div className="col-md-4 ml-3 ba">
          <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Social Media Audit </h4>
            <p>
            We do a complete evaluation of your current social media presence before outlining a suitable social media strategy. This includes examining your social media accounts in great detail, scrutinising the type of content you share, your frequency of sharing, and your engagement statistics. This allows us to identify areas that need improvement.
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Social Media Strategy </h4>
            <p>
            Following the audit, we develop a social media plan targeting your company's needs. This entails developing an individual plan of action for each platform, including the type of material to post and the frequency of posting.
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Content Creation</h4>
            <p>
            We understand that developing compelling content can be a daunting task for businesses. To address this problem, we provide exclusive content development services, covering all aspects of content creation, from content writing to graphic designing, photography, and copywriting. Our content developers work with you in close collaboration to create material that is relevant to your audience.
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Social Media Management</h4>
            <p>
            Maintaining multiple social media accounts can be time-consuming and necessitates a dedicated crew. Our social media management team regularly monitors your accounts, sends regular replys to the comments and messages received, and posts content on your behalf. This keeps your social media profiles active and engaging.
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Social Media Advertising </h4>
            <p>
            We provide social media advertising services to help expand your brand’s reach. This involves developing and deploying advertisements that touch your targeted demographic, resulting in fresh leads and conversions. Also, our team regularly evaluates and adjusts your ads based on performance to ensure optimal results.
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Social Media Analytics and Reporting</h4>
            <p>
            We believe in openness and accountability. As a result, we offer regular analytics and reports that track the response generated by your social media posts. This involves examining engagement indicators such as likes, comments, and shares, allowing us to fine-tune our social media strategy and ensure your business objectives are met with laser-sharp precision.
            </p>
          </div>
          </span>
        </div>
      </div>
    </div>
  </section>
  <section className="py-5 price mb-5">
    <div className="">
      <div className="container">
        <h1 className=" text-center pb-5"> <span className="sub-color">Social Media Marketing</span> Packages</h1>
        <div className="row">
          <div className="col-lg-4 col-md-6 price-style">
            <div className="pricingTable10">
              <div className="pricingTable-header">
                <h3 className="heading">SMO Packages - Basic</h3>
                <span className="price-value">
                <span className="currency">₹</span> 15,000
                <span className="month">/monthly</span><br />
                <span className="month">EXCLUSIVE OF ALL TAXES</span>
                </span>
              </div>
              <div className="pricing-content">
                <ul>
                  <li className="sub-color font-weight-bold text-center">STRATEGY CREATION</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Setting Goals </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Target Audience Analysis </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Content Strategy Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Hashtag Research </li>
                  <li className="sub-color font-weight-bold text-center">FACEBOOK MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Creation </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Optimization </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Call-to-action button setup  </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Regular Posts - 4 </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Post Sharing In Groups - 3</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Video Sharing (Video provided by client)</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Competitor Analysis</li>
                  <li><i className="fa fa-times  pr-2" aria-hidden="true"></i>		Business Manager Account Set Up</li>
                  <li><i className="fa fa-times  pr-2" aria-hidden="true"></i>		FB Timeline Status Posting</li>
                  <li className="sub-color font-weight-bold text-center">FB AD CAMPAIGN SET UP</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Ad Campaign - 1</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Ad Campaign Monitoring </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Pixel Installation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Traffic Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Audience Creation </li>
                  <li className="sub-color font-weight-bold text-center">TWITTER MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Regular Tweets - 4</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Retweets - 2 </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Twitter Analytics Monitoring </li>
                  <li><i className="fa fa-times  pr-2" aria-hidden="true"></i>List Creation </li>
                  <li className="sub-color font-weight-bold text-center">INSTAGRAM MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Regular Posts - 4</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Instagram Analytics Monitoring </li>
                  <li><i className="fa fa-times  pr-2" aria-hidden="true"></i>Image Tagging</li>
                  <li>Instagram Ad Campaign Set Up (On request) </li>
                  <li className="sub-color font-weight-bold text-center">LINKEDIN MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Company Page Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Post Sharing - 4</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Relevant Group Joining - 1</li>
                  <li><i className="fa fa-times   pr-2" aria-hidden="true"></i>	Targeted Connections</li>
                  <li>Linkedin Ad Campaign Set Up (On request)</li>
                  <li className="sub-color font-weight-bold text-center">YOUTUBE MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Channel Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Channel Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Video Posting</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Video Optimization - 5</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Thumbnail Creation - 1</li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Video Tags research and Optimization</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Playlist Creation</li>
                  <li><i className="fa fa-times  pr-2" aria-hidden="true"></i>Comment Moderation</li>
                  <li className="sub-color font-weight-bold text-center">CUSTOMER SUPPORT</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Customer Support</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Email</li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Phone</li>
                  <li><i className="fa fa-times  pr-2" aria-hidden="true"></i>Skype/Online Support</li>
                </ul>
                <a href="#" className="read">Get Started Now</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 price-style">
            <div className="pricingTable10">
              <div className="pricingTable-header">
                <h3 className="heading">SMO Packages - Advanced</h3>
                <span className="price-value">
                <span className="currency">₹</span> 22,000
                <span className="month">/monthly</span><br />
                <span className="month">EXCLUSIVE OF ALL TAXES</span>
                </span>
              </div>
              <div className="pricing-content">
                <ul>
                  <li className="sub-color font-weight-bold text-center">STRATEGY CREATION</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Setting Goals </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Target Audience Analysis </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Content Strategy Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Hashtag Research </li>
                  <li className="sub-color font-weight-bold text-center">FACEBOOK MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Creation </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Optimization </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Call-to-action button setup  </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Regular Posts - 8 </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Post Sharing In Groups - 5</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Video Sharing (Video provided by client)</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Competitor Analysis</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Business Manager Account Set Up</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		FB Timeline Status Posting</li>
                  <li className="sub-color font-weight-bold text-center">FB AD CAMPAIGN SET UP</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Ad Campaign - 2</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Ad Campaign Monitoring </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Pixel Installation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Traffic Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Audience Creation </li>
                  <li className="sub-color font-weight-bold text-center">TWITTER MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Regular Tweets - 8</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Retweets - 4 </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Twitter Analytics Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>List Creation </li>
                  <li className="sub-color font-weight-bold text-center">INSTAGRAM MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Regular Posts - 8</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Instagram Analytics Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Image Tagging</li>
                  <li>Instagram Ad Campaign Set Up (On request) </li>
                  <li className="sub-color font-weight-bold text-center">LINKEDIN MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Company Page Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Post Sharing - 8</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Relevant Group Joining - 3</li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Targeted Connections</li>
                  <li>Linkedin Ad Campaign Set Up (On request)</li>
                  <li className="sub-color font-weight-bold text-center">YOUTUBE MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Channel Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Channel Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Video Posting</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Video Optimization - 8</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Thumbnail Creation - 3</li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Video Tags research and Optimization</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Playlist Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Comment Moderation</li>
                  <li className="sub-color font-weight-bold text-center">CUSTOMER SUPPORT</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Customer Support</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Email</li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Phone</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Skype/Online Support</li>
                </ul>
                <a href="#" className="read">Get Started Now</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 price-style">
            <div className="pricingTable10">
              <div className="pricingTable-header">
                <h3 className="heading">SMO Packages - Enterprise</h3>
                <span className="price-value">
                <span className="currency">₹</span>40,000
                <span className="month">/monthly</span><br />
                <span className="month">EXCLUSIVE OF ALL TAXES</span>
                </span>
              </div>
              <div className="pricing-content">
                <ul>
                  <li className="sub-color font-weight-bold text-center">STRATEGY CREATION</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Setting Goals </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Target Audience Analysis </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Content Strategy Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Hashtag Research </li>
                  <li className="sub-color font-weight-bold text-center">FACEBOOK MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Creation </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Optimization </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Call-to-action button setup  </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Regular Posts - 12 </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Post Sharing In Groups - 8</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Video Sharing (Video provided by client)</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Page Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Competitor Analysis</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		Business Manager Account Set Up</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>		FB Timeline Status Posting</li>
                  <li className="sub-color font-weight-bold text-center">FB AD CAMPAIGN SET UP</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>	Ad Campaign - 3</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Ad Campaign Monitoring </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Pixel Installation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Traffic Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Audience Creation </li>
                  <li className="sub-color font-weight-bold text-center">TWITTER MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Regular Tweets - 12</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Retweets - 6 </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Twitter Analytics Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>List Creation </li>
                  <li className="sub-color font-weight-bold text-center">INSTAGRAM MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Regular Posts - 12</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Instagram Analytics Monitoring </li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Image Tagging</li>
                  <li>Instagram Ad Campaign Set Up (On request) </li>
                  <li className="sub-color font-weight-bold text-center">LINKEDIN MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Profile Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Company Page Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Post Sharing - 12</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Relevant Group Joining - 5</li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Targeted Connections</li>
                  <li>Linkedin Ad Campaign Set Up (On request)</li>
                  <li className="sub-color font-weight-bold text-center">YOUTUBE MARKETING</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Channel Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Channel Optimization </li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Video Posting</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Video Optimization - 10</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Thumbnail Creation - 5</li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Video Tags research and Optimization</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Playlist Creation</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Comment Moderation</li>
                  <li className="sub-color font-weight-bold text-center">CUSTOMER SUPPORT</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Customer Support</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Email</li>
                  <li><i className="fa fa-check   pr-2" aria-hidden="true"></i>	Phone</li>
                  <li><i className="fa fa-check  pr-2" aria-hidden="true"></i>Skype/Online Support</li>
                </ul>
                <a href="#" className="read">Get Started Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="techUse-title text-center">
            <h1>  Why Hire <span className="sub-color">Social BFC Softtech's Media Marketing</span>  Services?</h1>
          </div>
        </div>
        <div className="col-md-12 text-center ">
          <p className="short-desc">If you want to propel the online presence of your business and drive more traffic to your website, you must use social media marketing. But, with so many sites to explore and algorithms that are always changing, undertaking social media marketing on your own can be daunting. The media marketing services provided by BFC Softtech can help you with this.
Here are just a few reasons why you should hire BFC Softtech for your social media marketing needs: </p>
        </div>
      </div>
      <div className="row py-lg-5">
        <section className="web-banner mb-4">
          <Carousel>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/dev.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title pt-3">
                            <h4 className="color-bluec ">Expertise </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">Our team of social media experts has years of expertise in the industry and understands how to create captivating content, grow a following, and drive traffic to your website. We keep up with the newest trends and algorithms to keep your brand's social media presence on the cutting edge.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/expert.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title ">
                            <h4 className="color-bluec ">Customized Approach </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">We understand that every business is unique, therefore we tailor our social media marketing strategies to match your specific goals and needs. We'll collaborate with you to create a customised plan that delivers results, whether you want to raise brand awareness, increase traffic to your website, or generate fresh leads.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/new/account.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title ">
                            <h4 className="color-bluec ">Cost-effective </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">Employing a full-time social media manager can be costly, and it may not be appropriate for small businesses. However, with BFC Sifttech, you can hire a team of social media professionals for a fraction of the cost, giving your social media efforts the edge it deserves.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/new/communicatio.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title ">
                            <h4 className="color-bluec ">Multi-Platform Expertise </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">With so many social media outlets to choose from, determining the ones suitable for your business needs can be difficult. Our team has extensive experience in maintaining social media accounts across all major platforms. We'll assist you in determining which platforms are most relevant for your company and develop a strategy that effectively engages your audience.
</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        </section>
      </div>
    </div>
  </section>
 
</div>
</>
)
}
export default Social_Media_Marketing